module.exports = __webpack_public_path__ + "static/img/11.aa88b46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/11.png
// module id = qpGx
// module chunks = 0